import React from 'react'
import { getCenterTitleTag } from '../../../domain/useCases/getCenterTitleTag'
import { generateSocialTags } from '../../../domain/seo/useCases/generateSocialTags'
import MetaData from '../../SEO/MetaData'

class CenterHead extends React.Component {
  constructor(props) {
    super(props)
    const { data, reviews, testimonials = [] } = props
    this.state = {
      isClosed: data.status === 'Closed',
      isClaimed: !!data.claimed_email,
      isVerified: !!data.certifications,
      acceptsInsurance: !!data.price[0]?.includes('Insurance'),
      hasReviews: reviews.length || testimonials.length,
      hasPricing:
        data.pricing_label !== 'Contact center for price' &&
        data.pricing_label !== null
    }
  }

  render() {
    const { data, canonicalLink } = this.props
    const {
      isClosed,
      isClaimed,
      isVerified,
      acceptsInsurance,
      hasReviews,
      hasPricing
    } = this.state

    const locationLabelParts = data?.location_label?.split(', ')
    const locationLabel =
      locationLabelParts?.length > 1
        ? `${locationLabelParts[0]}, ${locationLabelParts[1]}`
        : data?.location_label

    const titleTag = getCenterTitleTag(
      isVerified,
      hasReviews,
      isClaimed,
      hasPricing,
      locationLabel,
      data.title,
      isClosed,
      acceptsInsurance
    )

    const trimmedTitleTag = titleTag.trim()

    const pageDescription = data.short_description

    const socialTagsData = generateSocialTags(
      trimmedTitleTag,
      data.short_description,
      'website',
      canonicalLink,
      data.featured_image
    )

    return (
      <MetaData
        pageTitle={trimmedTitleTag}
        pageDescription={pageDescription}
        canonicalLink={canonicalLink}
        socialTagsData={socialTagsData}
      />
    )
  }
}

export default CenterHead
